<template>
    <div>
        <el-dropdown-item @click.native="handleMark(1)">
            <!-- {{ markInfo.label }} -->
            {{ $t("message.button.bookmark") }}
        </el-dropdown-item>

        <el-dropdown-item @click.native="handleMark">
            <!-- {{ markInfo.label }} -->
            {{ $t("message.button.cancelBookmark") }}
        </el-dropdown-item>

        <el-dropdown-item @click.native="deleteItem" v-if="isRoot" :disabled="deleteDisabled">{{
            $t("message.button.delete") }}
        </el-dropdown-item>
        <el-dropdown-item v-if="!milepost" @click.native="saveAsDialogVisible = true">
            {{ $t("message.button.saveAs") }}
        </el-dropdown-item>

        <!-- <el-dropdown-item @click.native="addFavorite">
            {{ $t("message.button.bookmark") }}
        </el-dropdown-item>
        <el-dropdown-item @click.native="removeFavorite">{{ $t("message.button.cancelBookmark") }}
        </el-dropdown-item>
        <el-dropdown-item :disabled="disable_show || !userDisable || !removeBtnPriv || !isExecuter"
            @click.native="deleteItem" v-show="isRoot">{{ $t("message.button.delete") }}
        </el-dropdown-item>
        <el-dropdown-item v-if="!milepost" @click.native="saveAsDialogVisible = true">
            {{ $t("message.button.saveAs") }}
        </el-dropdown-item> -->

        <el-dialog v-dialogDrag :title="$t('message.title.saveAs')" :visible.sync="saveAsDialogVisible" class="dialog"
            width="50%" @close="closeSaveAs" :append-to-body="true">
            <save-as @close="closeDialog" />
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import saveAs from "./saveAs.vue";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            markInfo: {
                label: "",
                id: 0,
            },
            list: [
                this.$t("message.button.bookmark"),
                this.$t("message.button.cancelBookmark"),
            ],
            saveAsDialogVisible: false, //另存为展示框
            milepost: false, //关卡里程碑另存为按钮不显示

            addForm: {},
            addFormRoles: {
                name: [
                    {
                        required: true,
                        message: this.$t("message.tips.inputName"),
                        trigger: "blur",
                    },
                    {
                        min: 3,
                        max: 25,
                        message: this.$t("message.warning.length_101"),
                        trigger: "blur",
                    },
                ],
            },
            // isRoot: false
        };
    },
    computed: {
        ...mapGetters({
            projectStatus: "projectWorkflow/getProjectInfo",
            pageOne: 'project/getPageOne',
            getPriv: "projectWorkflow/getPriv",

        }),
        isRoot() {
            const { isAdministrator, } = this.getPriv;
            const { isRoot } = this.projectStatus.specialProjectVo;
            return !!isRoot && isAdministrator
        },
        deleteDisabled() {
            const { currectStatus } = this.projectStatus, { statusType } = currectStatus;
            const { hasProjectPause } = this.getPriv;
            return hasProjectPause || statusType !== 1
        }

    },
    // watch: {
    //     'projectStatus.specialProjectVo'(val) {
    //         this.isRoot = val.isRoot
    //     }
    // },
    components: { saveAs },
    methods: {
        deleteItem() {
            this.$confirm(
                this.$t("message.confirm.deleteObject"),
                this.$t("message.tips.tip"),
                {
                    confirmButtonText: this.$t("message.button.affirm"),
                    cancelButtonText: this.$t("message.button.cancel"),
                    type: "warning",
                }
            )
                .then(() => {
                    return this.sendDelProject();
                })
                .then((_) => {
                    return this.removeRelationshipValueAPI();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: this.$t("message.tips.deleteCancel"),
                    });
                });
        },
        removeRelationshipValueAPI() {
            const systemCode = window.sessionStorage.getItem("systemCode") || "";
            if (systemCode.indexOf("medlinket") === -1) {
                return;
            }
            const { id: projectId, classId } = this.$store.state.objectId;
            return axios.post(`/ppm/project/removeRelationshipValue`, [
                { projectId, classId },
            ]);
        },
        sendDelProject() {
            const { id } = this.$store.state.objectId;
            axios
                .post(`/ppm/project/softDelScheduleByRootId?rootId=${id}`)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        // this.$emit("deletePage");
                        const obj = { rootId: id };
                        this.$store.dispatch("delPro", obj);
                        const item = this.$store.state.showingTabsInHome.at(-1);
                        console.log(item);

                        const nextPush = {
                            path: item.path,
                            query: item.query,
                        };
                        this.$router.push(nextPush);
                    } else {
                        this.$message({
                            type: "info",
                            message: this.$t("message.error.delete"),
                        });
                    }
                });
        },
        closeDialog() {
            this.saveAsDialogVisible = false;
        },
        handleMark(id) {
            const { columnInfo, rows } = this.pageOne, { ids } = columnInfo, [row] = rows, { cells } = row;
            const index = ids.indexOf(1051012);
            const number = cells[index].val;
// const id = 1 - this.markInfo.id;
            const obj = {
                baseClassId: this.Constants.projectBaseClassId,
                // number: this.title.name,
                number,
                ...this.$store.state.objectId,
            };
            if (id === 1) {
                this.addFavoriteInCommon(obj);
            } else {
                this.removeFavoriteInCommon(obj);
            }
            // this.markInfo = { id, label: this.list[id] };
        },
        closeSaveAs() {
            //this.$refs.addFormRef.clearValidate();
            this.addForm = {};
            this.templateVal = "3";
        },
    },
    created() {
        const { id } = this.markInfo;
        this.markInfo.label = this.list[id];
    },
};
</script>

<style></style>